import {
  videoModelSpecs,
  type VideoModelCode,
} from '../video-model/model-spec';

export const FRAME_IMAGE_MODEL_MAP = new Map(
  videoModelSpecs
    .entries()
    .filter(([_, spec]) => !spec.deprecated)
    .filter(([_, spec]) => spec.frame_image),
);

export const DEFAULT_FRAME_IMAGE_MODEL: VideoModelCode =
  'dreamina_seedance_fast';
